import React, { useState, useEffect, useCallback } from 'react';
import { Paragraph, Tab, Tabs, Box, Text, PageHeader, Page, PageContent, Button } from 'grommet';
import { Info } from '@hpe-design/icons-grommet';
import { MapTabContent } from '../../../components/MapTabContent';
import { ReferencesComp } from './references/ReferencesComp';
import { useLocation, useNavigate } from 'react-router-dom';
import './page.css';

const TAB_TITLES = ['demo', 'info'];

export const SmartSearchDemo = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Memoize getTabFromUrl to satisfy ESLint dependencies
  const getTabFromUrl = useCallback(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    return TAB_TITLES.includes(tab) ? tab : 'demo';
  }, [location.search]);

  const [activeLatestTab, setActiveLatestTab] = useState(getTabFromUrl());

  // ESLint fix: Added dependencies properly
  useEffect(() => {
    const tabFromUrl = getTabFromUrl();
    if (tabFromUrl !== activeLatestTab) {
      setActiveLatestTab(tabFromUrl);
    }
  }, [getTabFromUrl, activeLatestTab]);

  const handleTabChange = (index) => {
    const nextTab = TAB_TITLES[index];
    setActiveLatestTab(nextTab);
    
    // Using search params keeps us on the same page and prevents the "bounce"
    navigate({
      pathname: location.pathname,
      search: `?tab=${nextTab}`
    }, { replace: true });
  };

  const activeTabIndex = TAB_TITLES.indexOf(activeLatestTab);

  // --- COOL COMING SOON COMPONENT ---
  const ComingSoonContent = () => (
    <Box 
      align="center" 
      justify="center" 
      pad="xlarge" 
      animation={{ type: 'fadeIn', duration: 1000 }}
    >
      <Box 
        background="background-front" 
        pad="large" 
        round="medium" 
        elevation="medium"
        align="center"
        border={{ color: 'brand', size: 'small', style: 'dashed' }}
        style={{ maxWidth: '600px' }}
      >
        <Info size="large" color="brand" />
        <Text size="xxlarge" weight="bold" margin={{ top: 'medium' }}>
          Coming Soon
        </Text>
        <Paragraph textAlign="center" color="text-weak">
          We are currently aggregating the deep-dive technical architecture and 
          PCAI implementation details for the Smart Search project. 
        </Paragraph>
        <Button 
          label="Back to Demo" 
          primary 
          onClick={() => handleTabChange(0)} 
          margin={{ top: 'medium' }} 
        />
      </Box>
    </Box>
  );

  return (
    <Page flex="grow" background="transparent">
      <Box background="transparent" margin={{ top: 'none' }} pad={{ bottom: 'none' }}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader
            pad={{ top: '0px', bottom: '40px' }}
            title={
              <Text size="xxlarge" weight="bold" color="text-strong">
                HPE on HPE References
              </Text>
            }
            subtitle={
              <Text color="text" size="large">
                HPE, the BI Lab and PCAI in action
              </Text>
            }
          />
        </Box>
      </Box>

      <PageContent flex="grow" background="transparent" width="80%" style={{ minHeight: '100vh' }}>
        <Tabs
          activeIndex={activeTabIndex !== -1 ? activeTabIndex : 0}
          onActive={handleTabChange}
          justify="start"
        >
          <Tab title={<Text color="text-strong" weight="bold">Demo</Text>}>
            <Box pad={{ vertical: 'small' }}>
               {activeLatestTab === 'demo' && <ReferencesComp />}
            </Box>
          </Tab>
          
          <Tab title={<Text color="text-strong" weight="bold">Info</Text>}>
            <Box pad={{ vertical: 'small' }}>
              <MapTabContent>
                <ComingSoonContent />
              </MapTabContent>
            </Box>
          </Tab>          
        </Tabs>
      </PageContent>
    </Page>
  );
};